<template>
  <div class="CreateTestPaperModal">
    <!--    <CorrectPolyPhoneModal-->
    <!--        @refreshInputVal="refreshInputVal"-->
    <!--        :inputValArr="inputValArr"-->
    <!--    ></CorrectPolyPhoneModal>-->
    <el-dialog
        title="创建试卷"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-width="90px">
        <el-form-item label="试卷名称:" prop="name">
          <el-input
              v-model="formData.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="试题数量:" prop="testQuestionCount">
          <el-input-number
              v-model="formData.testQuestionCount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="题目标签:">
          <AppTreeSelect
              style="width: 250px"
              :options="tagData"
              :valueArr="formData.tagIds"
              @tagChange="tagChange"
          ></AppTreeSelect>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="handleCreateTestPaper">
          开始创建
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import SearchKnowledge from "@/pages/MyOutLine/SearchKnowledge.vue";
import CorrectPolyPhoneModal from "@/pages/MyOutLine/CorrectPolyPhoneModal.vue";
import {QUESTION_TYPE, SUBJECT_TYPE} from "@/utils/constants";
import MultiContentComponent from "@/pages/MyOutLine/components/MultiContentComponent.vue";
import ContentPickModal from "@/pages/MyOutLine/components/ContentPickModal.vue";
import AudioText from "@/pages/MyOutLine/components/AudioText.vue";
import testPaperList from "@/pages/QuestionBank/TestPaperList.vue";
import TagList from "@/pages/TagManagement/TagList.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";

export default {
  name: "CreateTestPaperModal",
  props: {},
  components: {AppTreeSelect, TagList},
  mixins: [],
  data() {
    return {
      visible: false,
      formData: this.defaultFormData(),
      rules: {
        name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
        ]
      },
      tagData: []
    };
  },
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.tagData = this.tagCategoryList.data;
  },
  methods: {
    ...mapActions("courseCenter", ["getTagCategoryList"]),
    ...mapActions("pluginCenter", ["createTestPaper"]),
    tagChange(val) {
      this.formData.tagIds = val;
    },
    handleCreateTestPaper() {
      this.$refs.form.validate(async (validate) => {
        if (validate) {
          let res = await this.createTestPaper(this.formData);
          this.$message.success("试卷创建成功")
          this.visible = false;
          this.$emit("created", res)
        }
      })
    },
    defaultFormData() {
      return {
        name: "",
        tagIds: [],
        testQuestionCount: 20
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.CreateTestPaperModal {
  width: 100%;
}
</style>
